import React, { forwardRef, HTMLAttributes, CSSProperties, cloneElement } from "react";
// @ts-ignore
import Product from "../../pages/products/components/Product";

export type ItemProps = HTMLAttributes<HTMLDivElement> & {
  id: string;
  isSorting: boolean;
  withOpacity?: boolean;
  isDragging?: boolean;
  data: any;
  item: any;
};

const Item = forwardRef<HTMLDivElement, ItemProps>(
  ({ id, withOpacity, isSorting, isDragging, data, item, style, ...props }, ref) => {
    const inlineStyles: CSSProperties = {
      opacity: withOpacity ? "0.5" : "1",
      transformOrigin: "50% 50%",
      //height: '140px',
      //width: '140px',
      borderRadius: "10px",
      cursor: isDragging ? "grabbing" : "grab",
      backgroundColor: "#ffffff",
      //  display: 'flex',
      //  justifyContent: 'center',
      //  alignItems: 'center',
      boxShadow: isDragging
        ? "rgb(63 63 68 / 5%) 0px 2px 0px 2px, rgb(34 33 81 / 15%) 0px 2px 3px 2px"
        : "rgb(63 63 68 / 5%) 0px 0px 0px 1px, rgb(34 33 81 / 15%) 0px 1px 3px 0px",
      transform: isDragging ? "scale(1.05)" : "scale(1)",
      ...style,
    };

    const buildPropsFromStrings = (data: any): any => {
      let newProps: any = {};
      Object.keys(data).map((key) => {
        if (key === "dispatch") {
          newProps[key] = data[key];
        } else if (key === "item") {
          newProps[data["model"]] = item;
        } else {
          newProps[key] = data[key];
        }
      });
      return newProps;
    };
    data = buildPropsFromStrings(data);
    switch (data["model"]) {
      case "product":
        return (
          <div
            id={id}
            ref={ref}
            style={inlineStyles}
            className={"inb-c-item inb-c-item--product medium-3 small-12 column"}
            {...props}
          >
            <Product isSorting={isSorting} {...data} />
          </div>
        );
      default:
        return (
          <div ref={ref} style={inlineStyles} {...props}>
            Nothing
          </div>
        );
    }
  },
);

export default Item;
